import styled from "styled-components";

const MultiOptions = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 8px 0px;
  padding: 0;
  max-width: fit-content;
  max-height: 70%;
`;

export default MultiOptions;
